import { render } from "./MobileHigreen.vue?vue&type=template&id=396e9995&scoped=true"
import script from "./MobileHigreen.vue?vue&type=script&lang=js"
export * from "./MobileHigreen.vue?vue&type=script&lang=js"

import "./MobileHigreen.vue?vue&type=style&index=0&id=396e9995&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396e9995"]])

export default __exports__